import { useMemo } from "react";

interface UseTickValuesProps<T extends Record<string, string | number>> {
  containerWidth: number;
  data: T[];
  estimatedLabelWidth?: number;
  indexBy: keyof T;
  marginOffset?: number;
}

export const useTickValues = <T extends Record<string, string | number>>({
  data,
  containerWidth,
  indexBy,
  estimatedLabelWidth = 80,
  marginOffset = 140,
}: UseTickValuesProps<T>): (string | number)[] =>
  useMemo(() => {
    const dataLength = data.length;
    const availableWidth = containerWidth - marginOffset; // Account for margins
    const maxLabels = Math.floor(availableWidth / estimatedLabelWidth);

    let tickInterval: number;
    if (dataLength <= maxLabels) {
      tickInterval = 1; // Show all labels
    } else {
      tickInterval = Math.ceil(dataLength / maxLabels);
    }

    return data
      .filter((_, index) => index % tickInterval === 0)
      .map(item => item[indexBy]);
  }, [data, containerWidth, indexBy, estimatedLabelWidth, marginOffset]);
